export default __webpack_public_path__ + "static/media/Valorous Carcanet.3d78b34d.jpg";